interface PillToggleProps<T extends string> {
  label: string
  options: { id: T; label: string }[]
  value: T
  onChange: (value: T) => void
}

/**
 * Two or three ways of reading the same report — by day or by month, per day
 * or per invoice.
 *
 * The same pill row the period presets wear, so a control that reshapes the
 * table reads as part of the filter bar rather than as a second toolbar.
 */
export function PillToggle<T extends string>({
  label,
  options,
  value,
  onChange,
}: PillToggleProps<T>) {
  return (
    <div
      role="group"
      aria-label={label}
      className="border-border bg-surface inline-flex gap-1 rounded-full border p-1"
    >
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={value === option.id}
          onClick={() => onChange(option.id)}
          className={`rounded-full px-3 py-1 text-xs transition-colors ${
            value === option.id
              ? 'bg-background text-foreground font-medium shadow-sm'
              : 'text-muted hover:text-foreground'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
